import Vue from 'vue'
import VueRouter from 'vue-router'
// import Pages from '../views/pages/pages.vue'
import Index from '../views/index/index.vue'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'index',
		component: Index
	},
	// {
	//   path: '/Pages',
	//   name: 'Pages',
	//   component: Pages
	// },
	{
		path: '/list',
		name: 'list',
		component: () =>
			import('@/views/list/list'), //列表
	},
	{
		path: '/pages/goods/goods',
		name: 'details',
		component: () =>
			import('@/views/details/details'), //详情
	},
	{
		path: '/cat',
		name: 'cat',
		component: () =>
			import('@/views/cat/cat'), //购物车
	},
	{
		path: '/submitOrder',
		name: 'submitOrder',
		component: () =>
			import('@/views/submitOrder/submitOrder'), //提交订单
	},
	{
		path: '/shop',
		name: 'shop',
		component: () =>
			import('@/views/shop/shop'), //提交订单
	},
	{
		path: '/shopClassify',
		name: 'shopClassify',
		component: () =>
			import('@/views/shop/shopClassify'), //提交订单
	},
	{
		path: '/ttshop_user',
		name: 'ttshop_user',
		component: () =>
			import('@/views/user/ttshop_user'), //个人中心
	},
	{
		path: '/ttshop_usermyorder',
		name: 'ttshop_usermyorder',
		component: () =>
			import('@/views/user/ttshop_usermyorder'), //我的订单
	},
	{
		path: '/ttshop_orderxq',
		name: 'ttshop_orderxq',
		component: () =>
			import('@/views/user/ttshop_orderxq'), //待支付订单
	}, ,
	{
		path: '/ttshop_usernews',
		name: 'ttshop_usernews',
		component: () =>
			import('@/views/user/ttshop_usernews'), //个人信息
	},
	{
		path: '/ttshop_security',
		name: 'ttshop_security',
		component: () =>
			import('@/views/user/ttshop_security'), //修改密码
	},
	{
		path: '/ttshop_siterun',
		name: 'ttshop_siterun',
		component: () =>
			import('@/views/user/ttshop_siterun'), //地址管理
	},
	{
		path: '/ttshop_accountaq',
		name: 'ttshop_accountaq',
		component: () =>
			import('@/views/user/ttshop_accountaq'), //账户安全
	},
	{
		path: '/ttshop_mybalance',
		name: 'ttshop_mybalance',
		component: () =>
			import('@/views/user/ttshop_mybalance'), //我的余额
	},
	{
		path: '/ttshop_recharge',
		name: 'ttshop_recharge',
		component: () =>
			import('@/views/user/ttshop_recharge'), //余额充值
	},
	{
		path: '/ttshop_coupon',
		name: 'ttshop_coupon',
		component: () =>
			import('@/views/user/ttshop_coupon'), //我的优惠券
	},
	{
		path: '/ttshop_integral',
		name: 'ttshop_integral',
		component: () =>
			import('@/views/user/ttshop_integral'), //我的积分
	},
	{
		path: '/ttshop_barter',
		name: 'ttshop_barter',
		component: () =>
			import('@/views/user/ttshop_barter'), //我要换货/退货
	},
	{
		path: '/ttshop_barteragree',
		name: 'ttshop_barteragree',
		component: () =>
			import('@/views/user/ttshop_barteragree'), //我要换货/退货(商家同意后)
	},
	{
		path: '/ttshop_darterttdelivery',
		name: 'ttshop_darterttdelivery',
		component: () =>
			import('@/views/user/ttshop_darterttdelivery'), //我要换货/退货(商家发货)
	},
	{
		path: '/ttshop_evaluate',
		name: 'ttshop_evaluate',
		component: () =>
			import('@/views/user/ttshop_evaluate'), //评价
	},
	{
		path: '/ttshop_mycollection',
		name: 'ttshop_mycollection',
		component: () =>
			import('@/views/user/ttshop_mycollection'), //我的收藏
	},
	{
		path: '/ttshop_store',
		name: 'ttshop_store',
		component: () =>
			import('@/views/user/ttshop_store'), //关注的店铺
	},
	{
		path: '/ttshop_invoice',
		name: 'ttshop_invoice',
		component: () =>
			import('@/views/user/ttshop_invoice'), //我的发票
	},
	{
		path: '/ttshop_invoicexq',
		name: 'ttshop_invoicexq',
		component: () =>
			import('@/views/user/ttshop_invoicexq'), //我的发票详情
	},
	{
		path: '/signin',
		name: 'signin',
		component: () =>
			import('@/views/signup/signin'), //登录
	},
	{
		path: '/binding',
		name: 'binding',
		component: () =>
			import('@/views/signup/binding'), //绑定手机号
	},
	{
		path: '/register',
		name: 'register',
		component: () =>
			import('@/views/signup/register'), //注册
	},
	{
		path: '/password',
		name: 'password',
		component: () =>
			import('@/views/signup/password'), //注册
	},
	{
		path: '/ttshop_details',
		name: 'ttshop_details',
		component: () =>
			import('@/views/signup/ttshop_details'), //详情页
	},
	{
		path: '/seckill',
		name: 'seckill',
		component: () =>
			import('@/views/seckill/seckill'), //秒杀
	},
	{
		path: '/apply',
		name: 'apply',
		component: () =>
			import('@/views/mch/apply'), //商家入驻
	},
	{
		path: '/payment',
		name: 'payment',
		component: () =>
			import('@/views/mch/payment'), //商家入驻缴纳保障金
	},
	{
		path: '/shopstore',
		name: 'shopstore',
		component: () =>
			import('@/views/shop/shopStore'), //店铺街
	},
	{
		path: '/allsort',
		name: 'allsort',
		component: () =>
			import('@/views/allsort/allsort'), //全部分类
	},
	{
		path: '/integral',
		name: 'integral',
		component: () =>
			import('@/views/integral/integral'), //积分商城
	},

	//企业采购
	{
		path: '/:route_url/:act_key/qycgindex',
		name: 'qycgindex',
		component: () =>
			import('@/views/enterprisepurchase/index/qycgindex'), //企业采购 -> 首页
	},
	// {
	// 	path: '/:route_url/qycgindex',
	// 	name: 'qycgindex1',
	// 	component: () =>
	// 		import('@/views/enterprisepurchase/index/qycgindex'), //企业采购 -> 首页
	// },
	{
		path: '/:route_url/:act_key/qycglist',
		name: 'qycglist',
		component: () =>
			import('@/views/enterprisepurchase/qycglist/qycglist'), //企业采购 -> 商品列表
	},
	// {
	// 	path: '/:route_url/qycglist',
	// 	name: 'qycglist1',
	// 	component: () =>
	// 		import('@/views/enterprisepurchase/qycglist/qycglist'), //企业采购 -> 商品列表
	// },
	{
		path: '/:route_url/:act_key/qycgdetails',
		name: 'qycgdetails',
		component: () =>
			import('@/views/enterprisepurchase/qycgdetails/qycgdetails'), //企业采购 -> 商品详情
	},
	{
		path: '/:route_url/qycgdetails',
		name: 'qycgdetails1',
		component: () =>
			import('@/views/enterprisepurchase/qycgdetails/qycgdetails'), //企业采购 -> 商品详情
	},
	{
		path: '/:route_url/:act_key/qycgcart',
		name: 'qycgcart',
		component: () =>
			import('@/views/enterprisepurchase/qycgcart/qycgcart'), //企业采购 -> 购物车
	},
	{
		path: '/:route_url/qycgcart',
		name: 'qycgcart1',
		component: () =>
			import('@/views/enterprisepurchase/qycgcart/qycgcart'), //企业采购 -> 购物车
	},
	// {
	// 	path: '/:route_url/submitOrder',
	// 	name: 'submitOrder',
	// 	component: () =>
	// 		import('@/views/submitOrder/submitOrder'), //提交订单
	// },
	// {
	// 	path: '/:route_url/:act_key/personal',
	// 	name: 'personal',
	// 	component: () =>
	// 		import('@/views/enterprisepurchase/personal/personal'), //企业采购 -> 个人中心
	// },
	{
		path: '/:route_url/personal',
		name: 'personal',
		component: () =>
			import('@/views/enterprisepurchase/personal/personal'), //企业采购 -> 个人中心
	},
	{
		path: '/:route_url/:act_key/purchase',
		name: 'purchase',
		component: () =>
			import('@/views/enterprisepurchase/purchase/purchase'), //企业采购 -> 采购审批权限设置
	},
	{
		path: '/:route_url/purchase',
		name: 'purchase1',
		component: () =>
			import('@/views/enterprisepurchase/purchase/purchase'), //企业采购 -> 采购审批权限设置
	},
	{
		path: '/:route_url/:act_key/activities',
		name: 'activities',
		component: () =>
			import('@/views/enterprisepurchase/activities/activities'), //企业采购 -> 活动管理
	},
	{
		path: '/:route_url/activities',
		name: 'activities1',
		component: () =>
			import('@/views/enterprisepurchase/activities/activities'), //企业采购 -> 活动管理
	},
	{
		path: '/:route_url/invoiceInformation',
		name: 'invoiceInformation',
		component: () =>
			import('@/views/enterprisepurchase/invoiceInformation/invoiceInformation'), //企业采购 -> 发票信息
	},
	{
		path: '/:route_url/reconciliation',
		name: 'reconciliation',
		component: () =>
			import('@/views/enterprisepurchase/reconciliation/reconciliation'), //企业采购 -> 对账管理
	},
	{
		path: '/:route_url/:act_key/framework',
		name: 'framework',
		component: () =>
			import('@/views/enterprisepurchase/framework/framework'), //企业采购 -> 组织架构
	},
	{
		path: '/:route_url/framework',
		name: 'framework1',
		component: () =>
			import('@/views/enterprisepurchase/framework/framework'), //企业采购 -> 组织架构
	},
	{
		path: '/:route_url/:act_key/ordercenter',
		name: 'ordercenter',
		component: () =>
			import('@/views/enterprisepurchase/ordercenter/ordercenter'), //企业采购 -> 订单中心
	},
	{
		path: '/:route_url/ordercenter',
		name: 'ordercenter1',
		component: () =>
			import('@/views/enterprisepurchase/ordercenter/ordercenter'), //企业采购 -> 订单中心
	},
	{
		path: '/:route_url/:act_key/userorderdetails',
		name: 'userorderdetails',
		component: () =>
			import('@/views/enterprisepurchase/orderdetails/userorderdetails'), //企业采购 -> 订单中心
	},
	{
		path: '/:route_url/userorderdetails',
		name: 'userorderdetails1',
		component: () =>
			import('@/views/enterprisepurchase/orderdetails/userorderdetails'), //企业采购 -> 订单中心
	},
	{
		path: '/:route_url/:act_key/ttshop_barters',
		name: 'ttshop_barters',
		component: () =>
			import('@/views/enterprisepurchase/orderdetails/ttshop_barters'), //企业采购 -> 售后
	},
	{
		path: '/:route_url/ttshop_barters',
		name: 'ttshop_barters1',
		component: () =>
			import('@/views/enterprisepurchase/orderdetails/ttshop_barters'), //企业采购 -> 售后
	},
	{
		path: '/:route_url/:act_key/userlist',
		name: 'userlist',
		component: () =>
			import('@/views/enterprisepurchase/activities/userlist'), //企业采购 -> 用户订单列表
	},
	{
		path: '/:route_url/userlist',
		name: 'userlist1',
		component: () =>
			import('@/views/enterprisepurchase/activities/userlist'), //企业采购 -> 用户订单列表
	},
	{
		path: '/:route_url/:act_key/qycgsubmitorder',
		name: 'qycgsubmitorder',
		component: () =>
			import('@/views/enterprisepurchase/submitorder/submitorder'), //企业采购 -> 提交订单
	},
	{
		path: '/:route_url/qycgsubmitorder',
		name: 'qycgsubmitorder1',
		component: () =>
			import('@/views/enterprisepurchase/submitorder/submitorder'), //企业采购 -> 提交订单
	},
	{
		path: '/:route_url/:act_key/orderdetails',
		name: 'orderdetails',
		component: () =>
			import('@/views/enterprisepurchase/orderdetails/orderdetails'), //企业采购 -> 订单详情
	},
	// {
	// 	path: '/:route_url/orderdetails',
	// 	name: 'orderdetails1',
	// 	component: () =>
	// 		import('@/views/enterprisepurchase/orderdetails/orderdetails'), //企业采购 -> 订单详情
	// },

	{
		path: '/:route_url/:act_key/shorderdetails',
		name: 'shorderdetails',
		component: () =>
			import('@/views/enterprisepurchase/orderdetails/shorderdetails'), //企业采购 -> 售后订单详情
	},
	{
		path: '/:route_url/orderdetails',
		name: 'shorderdetails1',
		component: () =>
			import('@/views/enterprisepurchase/orderdetails/shorderdetails'), //企业采购 -> 售后订单详情
	},

	{
		path: '/:route_url/:act_key/allorderlist',
		name: 'allorderlist',
		component: () =>
			import('@/views/enterprisepurchase/allorderlist/allorderlist'), //企业采购 -> 全部订单页
	},
	{
		path: '/:route_url/allorderlist',
		name: 'allorderlist1',
		component: () =>
			import('@/views/enterprisepurchase/allorderlist/allorderlist'), //企业采购 -> 全部订单页
	},
	{
		path: '/:route_url/:act_key/qycglogin',
		name: 'qycglogin',
		component: () =>
			import('@/views/enterprisepurchase/login/qycglogin'), //企业采购 -> 登录
	},
	{
		path: '/:route_url/qycglogin',
		name: 'qycglogin1',
		component: () =>
			import('@/views/enterprisepurchase/login/qycglogin'), //企业采购 -> 登录
	},
	{
		path: '*',
		name: '404',
		component: () =>
			import('@/views/enterprisepurchase/404/404'), //企业采购 -> 登录
	},
	{
		path: '/404',
		name: '404',
		component: () =>
			import('@/views/enterprisepurchase/404/404'), //企业采购 -> 登录
	},
]
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
	mode: 'hash',
	routes
})

export default router